// No credentials or transport here. The UI supplies the existing authenticated client.
export function createCampaignRequests(client, publish) {
  let generation = 0;
  let disposed = false;
  async function run(operation) {
    if (disposed) return;
    const ticket = ++generation;
    publish({ kind: 'loading' });
    try {
      const response = await operation();
      if (!disposed && ticket === generation) publish({ kind: 'ready', data: response.data });
    } catch {
      if (!disposed && ticket === generation) publish({ kind: 'error' });
    }
  }
  return {
    load: (page = 0) => run(() => client.get('/api/v1/campaigns/workspace', { params: { page, size: 20 } })),
    save: (id, name, description) => run(async () => {
      await client.put(`/api/v1/campaigns/${encodeURIComponent(id)}/draft-details`, { name, description });
      if (disposed) return { data: null };
      return client.get('/api/v1/campaigns/workspace', { params: { page: 0, size: 20 } });
    }),
    dispose: () => { disposed = true; ++generation; },
  };
}
